import { MaterialSymbol } from "@material-symbols/font-400";
import classNames from "classnames";
import { CSSProperties } from "react";

export type IconNames = MaterialSymbol;
interface IconProps {
  name: IconNames;
  size?: "2xsmall" | "xsmall" | "small" | "medium" | "large";
  style?: CSSProperties
  filled?: boolean;
  weight?: number;
}

const availableSizes = {
  "2xsmall": "0.75rem",
  xsmall: "1rem",
  small: "1.25rem",
  medium: "1.5rem",
  large: "2.5rem",
};

export function  Icon({
  name,
  size = "medium",
  style = {},
  weight = 400,
  filled,
  ...props
}: IconProps) {
  return (
    <span
      className={classNames(
        "material-symbols-rounded align-middle overflow-hidden",
        `font-[${weight}]`,
        {
          ["w-4 h-4"]: size === "xsmall",
          ["w-5 h-5"]: size === "small",
          ["w-6 h-6"]: size === "medium",
          ["w-10 h-10"]: size === "large",
        }
      )}
      style={{
        fontSize: availableSizes[size],
        ...(filled ? { fontVariationSettings: "'FILL' 1" } : {}),
        ...style,
      }}
      aria-hidden="true"
      {...props}
    >
      {name}
    </span>
  );
}
